import { combineReducers } from 'redux';

import claimMethods from './claimMethods';
import modals from './modals';

const rootClaimListingsReducer = combineReducers({
  claimMethods,
  modals,
});

export default rootClaimListingsReducer;
